export default __webpack_public_path__ + "static/media/map.dafb9a3a.svg";